import React, { Component } from 'react';
import ResponsiveImage from "../ResponsiveImage";

function PhoneNumber({ telephoneText, phoneNumber }) {

    let hasNumber = (phoneNumber !== null && phoneNumber.length > 0);

    return (        
        hasNumber ?
        <div className="contact-search__result-phone">
            {telephoneText}{' '}
            <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
        </div> : null
    );    
}

export default class ContactSearchHit extends Component {
  render() {
    return (
      <div className="contact-search__result">
        <div className="media">
          {this.props.hit.imageUri ? (
            <div className="contact-search__result-image">
            <ResponsiveImage
              url={this.props.hit.imageUri}
              height={this.props.hit.imageHeight}
              width={this.props.hit.imageWidth}
              alt={this.props.hit.name}
              defaultSize={[135, 135]}
              sizes={[135, 270, 405, 540]}
            />
            </div>
          ) : null}
          <div className="media-body">
            <h2 className="contact-search__result-name">
              {this.props.hit.name}
            </h2>
            <div className="contact-search__result-role">
              {this.props.hit.role}
            </div>
            <div className="contact-search__result-email">
              <a href={`mailto:${this.props.hit.email}`}>{this.props.hit.email}</a>
                    </div>
                                
            <PhoneNumber 
                phoneNumber={this.props.hit.phoneNumber}
                telephoneText={this.props.translations.telephone}
            />

            <div className="contact-search__result-description">
              {this.props.hit.description}
            </div>
            <div className="contact-search__result-campus">
              {this.props.hit.campusName}
              <br />
              {this.props.hit.campusAddress != null ? this.props.hit.campusAddress.split('\n').map((item, key) => {
                return (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                );
              }) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}